export default "__VITE_ASSET__H5VGV5_Z__"